import { gql } from '@apollo/client';

export const GET_PROFILE_FILE = gql`
  query GetProfileFile($fileId: Int) {
    getProfileFile(fileId: $fileId) {
      id
      createdAt
      updatedAt
      employeeId
      name
      imageUrl
      type
      deletedAt
    }
  }
`;

export const GET_PROFILE_FILE_AS_EMPLOYER = gql`
  query GetProfileFileAsEmployer($fileId: Int, $profileId: Int) {
    getProfileFileAsEmployer(
      fileId: $fileId
      profileId: $profileId
    ) {
      id
      createdAt
      updatedAt
      employeeId
      name
      type
      deletedAt
    }
  }
`;
export const GET_ALL_FILES_FOR_PROFILE = gql`
  query GetAllFilesForProfile {
    getAllFilesForProfile {
      id
      createdAt
      updatedAt
      employeeId
      name
      imageUrl
      type
      deletedAt
    }
  }
`;
export const GET_ALL_FILES_FROM_EMPLOYER = gql`
  query GetAllFilesFromEmployer($profileId: Int) {
    getAllFilesFromEmployer(profileId: $profileId) {
      id
      createdAt
      updatedAt
      employeeId
      name
      type
      deletedAt
    }
  }
`;
